var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapesStreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.75.75h7s1 0 1 1v7s0 1-1 1h-7s-1 0-1-1v-7s0-1 1-1Zm12.5 4.5a4.5 4.5 0 1 0 9.002 0 4.5 4.5 0 0 0-9.002 0Zm4.536 8.727a.886.886 0 0 0-1.572 0l-4.337 7.807a1.028 1.028 0 0 0-.007.976.905.905 0 0 0 .793.49h8.674a.906.906 0 0 0 .793-.49 1.027 1.027 0 0 0-.007-.976l-4.337-7.807Zm-12.935-.943a.778.778 0 0 0-1.2 0l-3.71 4.437a.827.827 0 0 0 0 1.058l3.708 4.437a.779.779 0 0 0 1.2 0l3.708-4.437a.827.827 0 0 0 0-1.058l-3.706-4.437Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesStreamlineUltimate);
export default __webpack_public_path__ + "static/media/Shapes--Streamline-Ultimate.d93dfd47412d7544daf07e96505f5e2d.svg";
export { ForwardRef as ReactComponent };